import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { Footer } from './Footer';
import { BottomNav } from './BottomNav';
import { usePreferencesStore } from '@/store/preferencesStore';
import { preferencesApi } from '@/api/preferencesApi';
import { useAuthStore } from '@/store/authStore';

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { sidebarCollapsed, toggleSidebarCollapsed, applyTheme, syncFromServer } = usePreferencesStore();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    applyTheme();
  }, [applyTheme]);

  useEffect(() => {
    if (!isAuthenticated) return;
    preferencesApi.getMine().then(syncFromServer).catch(() => {});
  }, [isAuthenticated, syncFromServer]);

  return (
    <div className="flex h-screen bg-surface-primary transition-colors duration-200">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={sidebarCollapsed}
        onToggleCollapse={toggleSidebarCollapsed}
      />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <TopBar onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 pb-20 lg:pb-6 scrollbar-thin">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
        <div className="hidden lg:block">
          <Footer />
        </div>
        <BottomNav onMoreClick={() => setSidebarOpen(true)} />
      </div>
    </div>
  );
}
